<template>
    <sub-page :fullPage="true" class="m-ledgerDetail">
        <div v-if="data" class="ledger-detail">
            <h2 class="ledger-title">{{data.dutyStart && data.dutyStart.slice(0,10)}} 排班详情</h2>
            <div class="ledger-items">
                <p>科室：{{data.office}}</p>
                <p>值班日期：{{data.dutyStart.slice(0,10)+'—'+data.dutyEnd.slice(0,10)}}</p>

                <p>值班队长：{{data.captain}}</p>
                <p>分队总人数：{{data.contingentNum}}</p>

                <p>分队出勤人数：{{data.contingentAttendance}}</p>
                <p>逸飞祥/员通/外岗/体测人数：{{data.offStaffNum}}</p>

                <p>加班人数：{{data.overtimeNum}}</p>
                <p>出勤总人数：{{data.attendanceNum}}</p>

            </div>
            <div class="ledger-members">
                <h3>国内出发值班人员：</h3>
                <div class="members">
                    <el-tag size="small" v-for="item in data.inlandMembers" :key="item.userId">{{item.userName}}</el-tag>
                </div>
            </div>
            <div class="ledger-members">
                <h3>当日外岗值班人员：</h3>
                <div class="members">
                    <el-tag size="small" v-for="item in data.offStaffMembers" :key="item.userId">{{item.userName}}</el-tag>
                </div>
            </div>
            <div class="ledger-members">
                <h3>当日紧急其他值班人员：</h3>
                <div class="members">
                    <el-tag size="small" v-for="item in data.emergencyMembers" :key="item.userId">{{item.userName}}</el-tag>
                </div>
            </div>
            <div v-if="initFiles.length" class="ledger-attachment">
                <h3>附件 (<span style="color:#22B9FF"> {{initFiles.length}} </span>)：</h3>
                <ledger-file :initFiles="initFiles" :readonly="true"></ledger-file>
            </div>
            
        </div>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage.vue'
    import ledgerFile from './Components/File'

    export default {
        props: ['attendanceId'],
        components: {
            SubPage, ledgerFile
        },
        data() {
            return {
                data: null,
                initFiles: []
            }
        },
        created() {
            this.initData()
        },
        mounted() {
           
        },
         destroyed(){
            this.$emit('onClose');
        },
        methods: {
            initData() {
                api.getTimeSheetPlanDetail(this.attendanceId).then(res => {
                    this.data = res.data;
                    this.initFiles = this.data.accessory;
                })
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .ledger-detail {
        width: 960px;
        margin: 0 auto;

        .ledger-title {
            margin-bottom: 20px;
            text-align: center;
            font-size: 20px;
        }

        .ledger-items {
            display: flex;
            flex-wrap: wrap;
            padding-bottom: 5px;
            line-height: 1.6;
            //border-bottom: 1px solid #dcdfe6;
            > p {
                flex-basis: 50%;
                margin-bottom: 10px;
            }
        }

        .ledger-block {
            display: flex;
            margin-top: 20px;
            > h3 {
                width: 80px;
                text-align: right;
                margin-right: 5px;
            }
            > p {
                flex: 1;
            }
        }

        .ledger-members {
            @extend .ledger-block;
            margin-top: 5px;
            display: flex;
            .members {
                padding: 10px 10px 0 10px;
                flex: 1;
                max-height: 300px;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                overflow-y: auto;
                .el-tag {
                    margin-right: 8px;
                    width: 10%;
                    margin-bottom: 8px;
                    @include no-wrap
                }
            }
        }

        .ledger-content {
            @extend .ledger-block;
            line-height: 1.8;
        }

        .ledger-attachment {
            @extend .ledger-block;

            .ledger-file {
                flex: 1;
            }
            /deep/.el-upload-list__item {
                width: 135px;
                height: 135px;
                margin-right: 10px;
                margin-bottom: 10px;
            }
        }
    }
</style>
